import 'slick-carousel/slick/slick';

const scrollingTitles = {
    init:() => {
        //console.log(id);
        var section  = jQuery('.scrolling-titles');
        var track  = section.children();

        var trackHeight = track.height();
        var count = track.children().length;
        var distanceToMove = trackHeight/count;
        var activeTitle = 0;
        jQuery('.scrolling-titles__track').slick({
            vertical: true,
            arrows:false,
            autoplay: true,
            autoplaySpeed: 2500,
            infinite: true,
            draggable:false,
            pauseOnFocus:false
          });


    }
};

export default scrollingTitles;